import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Signal,
  effect,
  inject,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { User } from "firebase/auth";
import { StateModule } from "projects/shared-state/lib/state.module";
import { StateService } from "projects/shared-state/lib/state.service";
import { AppProfile } from "projects/shared-state/lib/types/types";
import { WorkflowState } from "projects/shared-state/public-api";
import { Subscription, tap } from "rxjs";

@Component({
  standalone: true,
  selector: "postgenie-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
  imports: [StateModule, FormsModule, ReactiveFormsModule],
})
export class ProfileComponent implements OnDestroy {
  stateService = inject(StateService);

  profileForm: FormGroup = new FormGroup({
    jobDescription: new FormControl("", [
      Validators.required,
      Validators.maxLength(50),
    ]),
    department: new FormControl("", [Validators.required]),
    additionalInfo: new FormControl(""),
  });

  charCount: Subscription;
  additionalInfoCount: number = 0;
  additionalInfoMax: number = 500;

  stateSignal$: Signal<{
    workflow: WorkflowState;
  }> = this.stateService.getAppState();

  @Input() user: User;
  @Output() profileEvent = new EventEmitter<any>();

  constructor() {
    effect(() => {
      this.charCount = this.profileForm.valueChanges
        .pipe(
          tap((profileForm) => {
            this.additionalInfoCount = profileForm.additionalInfo?.length;
          }),
        )
        .subscribe();

      const appProfile: AppProfile =
        this.stateSignal$().workflow.profile?.appProfile;
      if (appProfile) {
        this.profileForm.patchValue({
          jobDescription: appProfile.jobDescription || "",
          department: appProfile.department || "",
          additionalInfo: appProfile.additionalInfo || "",
        });
      }
    });
  }

  emitProfile(): void {
    this.profileEvent.emit(this.profileForm.value);
  }

  ngOnDestroy(): void {
    if (!this.charCount.closed) {
      this.charCount.unsubscribe();
    }
  }
}
